import { useTheme } from 'foundations-theming/utils';
import ContentViewport from '../ContentViewport';
import { jsx as _jsx } from "react/jsx-runtime";
const InterstitialContentViewport = ({
  children,
  use = 'info',
  viewportStyles
}) => {
  const theme = useTheme();
  const extraViewportStyles = use === 'info' ? Object.assign({}, viewportStyles, {
    backgroundColor: theme.color['fill-surface-default']
  }) : Object.assign({}, viewportStyles, {
    background: `linear-gradient(225deg, ${theme.color['fill-accent-green-default']} 0%, ${theme.color['fill-accent-blue-default']} 100%)`,
    color: theme.color['text-core-on-fill-default']
  });
  return /*#__PURE__*/_jsx(ContentViewport, {
    viewportStyles: extraViewportStyles,
    children: children
  });
};
export default InterstitialContentViewport;